/*

This component renders either the left "previous page" button or the right "next page" button

*/

import React from 'react';

export default function PageNav(props) {

  // console.log(props);

  var p = props.prev;
  var n = props.next;
  var t = props.type;
  var c; // class
  var v = t === 'next' ? 1 : -1; // page change
  var a = t === 'next' ? "translate(12 1) rotate(90)" : "translate(2 22) rotate(-90)"; // arrow

  // define class

  if ((p === undefined) && (t === 'prev')) { // case: prev-button
    c = ' hide'
  } else if ((n === undefined) && (t === 'next')) { // case: next-button
    c = ''
  } else if (props.page === 0) {
    c = ' bounce'
  } else {
    c = ''
  }

  // define Los geht's button
  var nextButton = null;
  if (t === 'next') {
    if (props.page === 0) {
      nextButton = <button className="button opacity1">Let's go</button>
    } else if ((props.page === 1) && (props.direction === 'next')) {
      nextButton = <button className="button opacity0">Let's go</button>
    }
  }

  // define Zum Anfang button
  var beginButton = null;
  if (t === 'next' && props.page === 9) {
    beginButton = <button className="button toBegin">go to start</button>
  }

  function pageChange(value){
    props.onChange(value);
  }

  var c1 = props.cities.findIndex(city => city === props.city1);
  var c2 = props.cities.findIndex(city => city === props.city2);

  // arrow stroke width

  var winW = window.innerWidth;
  var line;
  if (winW < 500) {
    line = .9;
  } else if (winW < 750) {
    line = 1.1;
  } else if (winW < 1500) {
    line = 1.2;
  } else {
    line = 1.4;
  }

  // initial selected prof for page 5
  var activeProf = (props.page === 3) && (t === 'next') ? 'primaryschoolteacher' : undefined

  if (props.page === 9 && t === 'next') {
    return (
      <div className={'pageButton toBegin' + c}>
        <a id="ToBegin" href="https://www.superdot.studio/outofbalance/">
          {beginButton}
          <svg className="nextPage" xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23">
            <path d="M0,11,10,0,21,11" transform={a} fill="none" stroke="#000" strokeWidth={line}/>
          </svg>
        </a>
      </div>
    )
  } else {
    return (
      <div id={ t + "Page" } onClick={() => {
        pageChange({s: 'page', v: v});
        if (c1) {pageChange({s: 'city1', v: c1});};
        if (c2) {pageChange({s: 'city2', v: c2});};
        if (activeProf) {pageChange({s: 'activeProf', v: activeProf})};
      }} className={'pageButton' + c}>
        {nextButton}
        <svg className="nextPage" xmlns="http://www.w3.org/2000/svg" width="15" height="23" viewBox="0 0 15 23">
          <path d="M0,11,10,0,21,11" transform={a} fill="none" stroke="#000" strokeWidth={line}/>
        </svg>
      </div>
    )
  }


};
